export function decodeSpecialChars (text) {
  const div = document.createElement('div');

  return text.replace(/\&\#?[0-9a-z]+;/gi, (encoded) => {
    div.innerHTML = encoded;
    return div.innerText;
  });
}
